import { httpReducer, reduceReducers } from "../lib/create-action";
import {
  createDealActionName,
  dealClearValidationActionName,
  getDealForUserActionName,
  fetchDealActionName,
  getUnreadDealMessagesActionName,
  updateDealActionName,
} from "../action_managers/deals";
import get from "lodash/get";

const initialState = { isLoading: false, userDealUUIDs: [], isPutting: false };

const dealCreateReducer = httpReducer(createDealActionName, initialState, {
  success: (state, action) => ({
    ...state,
    [action.payload.resp.uuid]: action.payload.resp,
  }),
  failureBadRequest: (state, action) => ({
    ...state,
    validationErrors: get(action, "payload.validationErrors", []),
  }),
});

const dealFetchReducer = httpReducer(fetchDealActionName, initialState, {
  success: (state, action) => ({ ...state, [action.payload.resp.uuid]: action.payload.resp }),
});

const dealClearValidationReducer = (state, action) => {
  if (action.type === dealClearValidationActionName) {
    state = {
      ...state,
      validationErrors: null,
    };
  }
  return state;
};

const dealUpdateRequestReducer = httpReducer(
  updateDealActionName,
  initialState,
  {
    success: (state, action) => {
      return {
        ...state,
        [action.payload.resp.uuid]: action.payload.resp,
      };
    },
  },
  { loadingKeyName: "isPutting" }
);

const createDealForUserReducer = (actionName, showLoader) => {
  let config = { loadingKeyName: "no_loader" };
  if (showLoader) {
    config = {};
  }

  return httpReducer(
    actionName,
    initialState,
    {
      success: (state, action) => {
        const newDeals = {};
        const userDealUUIDs = [];
        action.payload.resp.forEach(deal => {
          userDealUUIDs.push(deal.uuid);
          newDeals[deal.uuid] = deal;
        });
        return {
          ...state,
          ...newDeals,
          userDealUUIDs,
        };
      },
    },
    config
  );
};

const dealUnreadMessagesReducer = httpReducer(
  getUnreadDealMessagesActionName,
  initialState,
  {
    success: (state, action) => {
      const unreadMessages = get(action.payload.resp, "unread", 0);
      return {
        ...state,
        unread: unreadMessages,
      };
    },
  },
  { loadingKeyName: "no_loader" }
);

export default reduceReducers(
  dealCreateReducer,
  dealFetchReducer,
  dealClearValidationReducer,
  dealUpdateRequestReducer,
  createDealForUserReducer(getDealForUserActionName, true),
  dealUnreadMessagesReducer
);
